export default __webpack_public_path__ + "static/media/video-placeholder.91feb6d0.png";